import { useMutation, useQueryClient } from "react-query";
import axios from "../axios";
import { AddItemResponse } from "../../constants/types";

type UpdateItemBody = {
    id: number | string;
    formData: FormData;
};

const updateItem = async ({ id, formData }: UpdateItemBody) => {
    const response = await axios.post<AddItemResponse>(
        `/api/item/${id}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
    );
    return response.data;
};

export default function useUpdateItem() {
    const queryClient = useQueryClient();

    return useMutation((body: UpdateItemBody) => updateItem(body), {
        onSuccess: () => {
            queryClient.invalidateQueries(["item"]);
        },
    });
}
